/**
 *
 * "Specify date formate"
 *
 * @file   dates.js
 * @author Lateral
 * @since  2023
 */
export const dateFormat = 'DD/MM/YYYY'
